import {IGetAIReviewJobDetailsResponse} from '../../../../../api/types/aiReview.type';

export const getJobDetailsMockResponse: IGetAIReviewJobDetailsResponse = {
  jobId: '1',
  jobName: 'Pricing Negotiation Review',
  type: 'ISSUE_CODE',
  description:
    'Review all documents related to pricing negotiations with ABC Corp',
  createdBy: 'john.doe@example.com',
  createdAt: '2024-01-15T14:30:00Z',
  status: 'PROCESSING',
  source: 'ABC_Corp_Emails_2023',
  sourceId: 1,
  caseContext:
    'Contract dispute involving alleged breach of pricing terms in Q3 2023',
  issueCodes: [
    {
      id: '1',
      code: 'PRICING',
      question: 'Does this document discuss pricing negotiations or terms?',
      description:
        'Documents containing discussions about product pricing, discounts, or pricing strategy',
    },
  ],
  relevanceCriteria:
    'Documents are relevant if they: (1) Discuss pricing terms; (2) Reference the ABC Corp contract; (3) Contain communications between parties about pricing disputes',
  groupId: '123e4567-e89b-12d3-a456-426614174000',
  groupName: 'Contract Dispute - Q1 2024',
};
